import { Typography, withStyles } from '@material-ui/core';
import PropTypes from 'prop-types';
import React from 'react';
import NumberFormat from 'react-number-format';

const styles = () => ({});
const propTypes = {
    disabledTypography: PropTypes.bool,
    plus: PropTypes.bool,
    prefix: PropTypes.bool,
    preText: PropTypes.string,
    value: PropTypes.number,
};
const defaultProps = {
    disabledTypography: false,
    plus: false,
    prefix: false,
    preText: '',
    suffix: '',
    value: 0,
};

function number({
    prefix, value, minus, plus, suffix, typographyProps, preText, disabledTypography,
}) {
    return (
        <NumberFormat
            allowNegative={false}
            value={value}
            displayType="text"
            prefix={prefix ? 'Rp. ' : ''}
            decimalSeparator=","
            thousandSeparator="."
            renderText={(e) => {
                if (disabledTypography) {
                    return (
                        <React.Fragment>
                            {preText ? `${preText} ` : ''}
                            {minus ? '- ' : ''}
                            {plus ? '+ ' : ''}
                            {e}
                            {suffix ? `${suffix} ` : ''}
                        </React.Fragment>
                    );
                }

                return (
                    <Typography {...typographyProps}>
                        {preText ? `${preText} ` : ''}
                        {minus ? '- ' : ''}
                        {plus ? '+ ' : ''}
                        {e}
                        {suffix ? `${suffix} ` : ''}
                    </Typography>
                );
            }}
        />
    );
}

number.displayName = 'number';
number.propTypes = propTypes;
number.defaultProps = defaultProps;

export default withStyles(styles, { name: 'number' })(number);
